"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentClient = void 0;
var config_1 = require("./config");
var RenderContentItem_1 = require("./rendering/coordinators/RenderContentItem");
var FilterBy_1 = require("./content/coordinators/FilterBy");
var GetContentItemV1Impl_1 = require("./content/coordinators/GetContentItemV1Impl");
var ContentMapper_1 = require("./content/mapper/ContentMapper");
var GetContentItemV2Impl_1 = require("./content/coordinators/GetContentItemV2Impl");
var GetContentItemsV2Impl_1 = require("./content/coordinators/GetContentItemsV2Impl");
var FilterByImpl_1 = require("./content/coordinators/FilterByImpl");
var createContentClient_1 = require("./client/createContentClient");
var NotSupportedError_1 = require("./content/model/NotSupportedError");
var GetHierarchyImpl_1 = require("./content/coordinators/GetByHierarchy/GetHierarchyImpl");
var FilteringHierachyAssemblerImpl_1 = require("./content/coordinators/GetByHierarchy/assemblers/FilteringHierachyAssemblerImpl");
var HierarchyAssemblerImpl_1 = require("./content/coordinators/GetByHierarchy/assemblers/HierarchyAssemblerImpl");
var MutatingHierarchyAssembler_1 = require("./content/coordinators/GetByHierarchy/assemblers/MutatingHierarchyAssembler");
var FilteringAndMutatingHierarchyAssembler_1 = require("./content/coordinators/GetByHierarchy/assemblers/FilteringAndMutatingHierarchyAssembler");
/**
 * Amplience [Content Delivery API](https://docs.amplience.net/integration/deliveryapi.html?h=delivery) client.
 *
 * This client is intended to be used by end user applications to fetch content so that it can be displayed to users.
 *
 * You must provide some configuration options in order to create an instance of ContentClient.
 * Example:
 *
 * ```typescript
 * const client = new ContentClient({
 *    account: 'test'
 * });
 * ```
 *
 * You may override other settings when constructing the client but if no additional configuration is provided sensible defaults will be used.
 */
var ContentClient = /** @class */ (function () {
    /**
     * Creates a Delivery API Client instance. You must provide a configuration object with the required details for the particular service you wish to fetch content from.
     * @param config Client configuration options
     */
    function ContentClient(config) {
        this.config = config;
        if (!config) {
            throw new TypeError('Parameter "config" is required');
        }
        if (!config.account &&
            !config.hubName) {
            throw new TypeError('Parameter "config" must contain a valid "account" name or "hubName" property');
        }
        if (config.stagingEnvironment &&
            config.stagingEnvironment.indexOf('://') !== -1) {
            throw new TypeError('Parameter "stagingEnvironment" should be a hostname not a URL');
        }
        this.contentMapper = this.createContentMapper(config);
        this.contentClient = (0, createContentClient_1.createContentClient)(config);
    }
    /**
     * @deprecated use getContentItemById
     */
    ContentClient.prototype.getContentItem = function (contentItemId) {
        return this.getContentItemById(contentItemId);
    };
    /**
     * This function will load a Content Item or Slot by id and return a Promise of the result.
     * If the content is not found the promise will reject with an error.
     * If the content is found the promise will resolve with a parsed version of the content with all dependencies.
     *
     * The content body will match the format defined by your content type, however keep in mind that if you have evolved your content type some published content may still be in the older format.
     *
     * Some pre-processing is applied to the content body to make it easier to work with:
     *
     * * Linked content items are joined together into the root content item to create a single JSON document.
     * * Media references (images and videos) are replaced with wrapper objects [[Image]] and [[Video]] which provide helper functions.
     * * Content created using V1 of the CMS will be upgraded to the V2 format.
     *
     * You can convert the content back to plain JSON by calling the toJSON() function on the returned ContentItem.
     * @typeparam T The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @param id Unique id of the Content Item or Slot to load
     */
    ContentClient.prototype.getContentItemById = function (id) {
        if ((0, config_1.isContentClientConfigV2)(this.config)) {
            return new GetContentItemV2Impl_1.GetContentItemV2Impl(this.config, this.contentClient, this.contentMapper).getContentItemById(id);
        }
        return new GetContentItemV1Impl_1.GetContentItemV1Impl(this.config, this.contentClient, this.contentMapper).getContentItemById(id);
    };
    /**
     * This function will load a Content Item or Slot by key and return a Promise of the result.
     * If the content is not found the promise will reject with an error.
     * If the content is found the promise will resolve with a parsed version of the content with all dependencies.
     *
     * A delivery key can be a simple string or a path such as "home-page/feature-banner". This makes it simpler to write your integration code and allows users more control over where items of content are delivered. You can add a delivery key to a slot in the Dynamic Content app or to a content item or slot using the Dynamic Content Management API.
     * Note that a delivery key may not start or end with "/" and must be between 1 and 150 characters. Delivery keys can contain the following alphanumeric characters: a to z, A to Z and 0 to 9. You can also include "-" and "_" and "/" as long as it is not included at the start or end of the key.
     *
     * The content body will match the format defined by your content type.
     *
     * Some pre-processing is applied to the content body to make it easier to work with:
     *
     * * Linked content items are joined together into the root content item to create a single JSON document.
     * * Media references (images and videos) are replaced with wrapper objects [[Image]] and [[Video]] which provide helper functions.
     * * Content created using V1 of the CMS will be upgraded to the V2 format.
     *
     * You can convert the content back to plain JSON by calling the toJSON() function on the returned ContentItem.
     * @typeparam T The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @param id Unique id of the Content Item or Slot to load
     */
    ContentClient.prototype.getContentItemByKey = function (key) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('getContentItemByKey');
        }
        return new GetContentItemV2Impl_1.GetContentItemV2Impl(this.config, this.contentClient, this.contentMapper).getContentItemByKey(key);
    };
    /**
     * This function will help construct requests for filtering Content Items or Slots
     *
     * @param filterBy - API options for `/content/filter` endpoint [docs](https://amplience.com/docs/development/contentdelivery/filterandsort.html)
     * @returns
     */
    ContentClient.prototype.filterContentItems = function (filterBy) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('filterContentItems');
        }
        return new FilterByImpl_1.FilterByImpl(this.config, this.contentClient).fetch(filterBy);
    };
    /**
     *  This function will help construct requests for filtering Content Items or Slots
     *
     * @param path - json path to property you wish to filter by e.g `/_meta/schema`
     * @param value - value you want to return matches for
     *
     * @returns `FilterBy<Body>`
     */
    ContentClient.prototype.filterBy = function (path, value) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('filterBy');
        }
        return new FilterBy_1.FilterBy(this.config, this.contentClient).filterBy(path, value);
    };
    /**
     *
     *  This function will help construct requests for filtering Content Items or Slots
     *
     *  equivalent to:
     *
     * ```ts
     *  client.filterBy('/_meta/schema', contentTypeUri)
     * ```
     *
     * @param contentTypeUri - Content Type Uri you want to filter
     *
     * @returns `FilterBy<Body>`
     */
    ContentClient.prototype.filterByContentType = function (contentTypeUri) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('filterByContentType');
        }
        return new FilterBy_1.FilterBy(this.config, this.contentClient).filterByContentType(contentTypeUri);
    };
    /**
     *  This function will help construct requests for filtering Content Items or Slots
     *
     * equivalent to:
     *
     * ```ts
     *  client.filterBy('/_meta/hierarchy/parentId', id)
     * ```
     *
     * @param id - ID of a Hierarchy Content Item
     *
     * @returns `FilterBy<Body>`
     */
    ContentClient.prototype.filterByParentId = function (id) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('filterByParentId');
        }
        return new FilterBy_1.FilterBy(this.config, this.contentClient).filterByParentId(id);
    };
    ContentClient.prototype.getHierarchyRootItem = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var rootItem, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
                            throw new NotSupportedError_1.NotSupportedV2Error('getByHierarchy');
                        }
                        if (!(requestParameters.rootItem === undefined)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getContentItemById(requestParameters.rootId)];
                    case 2:
                        rootItem = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error("Error while retrieving hierarchy root item: ".concat(err_1.message));
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        rootItem = requestParameters.rootItem;
                        _a.label = 6;
                    case 6:
                        if (rootItem.body._meta.deliveryId !== requestParameters.rootId) {
                            throw new Error("The root item id(".concat(requestParameters.rootItem.body._meta.deliveryId, ") ") +
                                "does not match the request rootId(".concat(requestParameters.rootId, ")"));
                        }
                        return [2 /*return*/, rootItem];
                }
            });
        });
    };
    /** This function will load a hierarchy and return the root item with any children attached,
     * it will also fetch the root item if needed.
     * @param requestParameters parameters for the hierarchies request see {@link ContentClientHierarchyRequest}
     * */
    ContentClient.prototype.getByHierarchy = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var rootItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHierarchyRootItem(requestParameters)];
                    case 1:
                        rootItem = _a.sent();
                        return [2 /*return*/, new GetHierarchyImpl_1.GetHierarchyImpl(this.contentClient, new HierarchyAssemblerImpl_1.HierarchyAssemblerImpl()).getHierarchyByRoot({
                                rootId: rootItem.body._meta.deliveryId,
                                maximumDepth: requestParameters.maximumDepth,
                                maximumPageSize: requestParameters.maximumPageSize,
                                sortOrder: requestParameters.sortOrder,
                                sortKey: requestParameters.sortKey,
                            }, rootItem)];
                }
            });
        });
    };
    /** This function will load a hierarchy and return the root item with any children attached,
     * it will also fetch the root item if needed.
     * @param requestParameters parameters for the hierarchies request see {@link ContentClientHierarchyRequest}
     * @param filterFunction the function that is applied to filter the tree, elements are removed on a truthy result
     * */
    ContentClient.prototype.getByHierarchyAndFilter = function (requestParameters, filterFunction) {
        return __awaiter(this, void 0, void 0, function () {
            var rootItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHierarchyRootItem(requestParameters)];
                    case 1:
                        rootItem = _a.sent();
                        return [2 /*return*/, new GetHierarchyImpl_1.GetHierarchyImpl(this.contentClient, new FilteringHierachyAssemblerImpl_1.FilteringHierachyAssemblerImpl(filterFunction)).getHierarchyByRoot({
                                rootId: rootItem.body._meta.deliveryId,
                                maximumDepth: requestParameters.maximumDepth,
                                maximumPageSize: requestParameters.maximumPageSize,
                                sortOrder: requestParameters.sortOrder,
                                sortKey: requestParameters.sortKey,
                            }, rootItem)];
                }
            });
        });
    };
    /** This function will load a hierarchy and return the root item with any children attached,
     * it will also fetch the root item if needed.
     * @param requestParameters parameters for the hierarchies request see {@link ContentClientHierarchyRequest}
     * @param mutationFunction the function that is applied to the content body while building the hierarchy
     * */
    ContentClient.prototype.getByHierarchyAndMutate = function (requestParameters, mutationFunction) {
        return __awaiter(this, void 0, void 0, function () {
            var rootItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHierarchyRootItem(requestParameters)];
                    case 1:
                        rootItem = _a.sent();
                        return [2 /*return*/, new GetHierarchyImpl_1.GetHierarchyImpl(this.contentClient, new MutatingHierarchyAssembler_1.MutatingHierachyAssemblerImpl(mutationFunction)).getHierarchyByRoot({
                                rootId: rootItem.body._meta.deliveryId,
                                maximumDepth: requestParameters.maximumDepth,
                                maximumPageSize: requestParameters.maximumPageSize,
                                sortOrder: requestParameters.sortOrder,
                                sortKey: requestParameters.sortKey,
                            }, rootItem)];
                }
            });
        });
    };
    ContentClient.prototype.getByHierarchyFilterAndMutate = function (requestParameters, filterFunction, mutationFunction) {
        return __awaiter(this, void 0, void 0, function () {
            var rootItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHierarchyRootItem(requestParameters)];
                    case 1:
                        rootItem = _a.sent();
                        return [2 /*return*/, new GetHierarchyImpl_1.GetHierarchyImpl(this.contentClient, new FilteringAndMutatingHierarchyAssembler_1.FilteringAndMutatingHierarchyAssembler(filterFunction, mutationFunction)).getHierarchyByRoot({
                                rootId: rootItem.body._meta.deliveryId,
                                maximumDepth: requestParameters.maximumDepth,
                                maximumPageSize: requestParameters.maximumPageSize,
                                sortOrder: requestParameters.sortOrder,
                                sortKey: requestParameters.sortKey,
                            }, rootItem)];
                }
            });
        });
    };
    /**
     * These functions will help construct requests for fetching multiple Content Items or Slots by delivery ID
     * and is equivalent to:
     *
     * ```ts
     *  client.fetchContentItems({
     *    parameters: {
     *      depth: 'all',
     *      format: 'inlined'
     *    },
     *    requests: [
     *      { id: '6cd4de36-591b-4ca2-874b-1dec7b681d7e' },
     *      { id: 'c6d9e038-591b-4ca2-874b-da354f5d6e61' },
     *    ],
     *  });
     * ```
     *
     * @param keys An array of Delivery keys of the content you wish to fetch
     * @typeparam Body The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @returns `Promise<FetchResponse<Body>>`
     */
    ContentClient.prototype.getContentItemsById = function (ids) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('getContentItemsById');
        }
        return new GetContentItemsV2Impl_1.GetContentItemsV2Impl(this.config, this.contentClient).getContentItemsById(ids);
    };
    /**
     * This function will help construct requests for fetching multiple Content Items or Slots by delivery key
     * and is equivalent to:
     *
     * ```ts
     *  client.fetchContentItems({
     *    parameters: {
     *      depth: 'all',
     *      format: 'inlined'
     *    },
     *    requests: [
     *      { key: 'blog/article-1' },
     *      { key: 'blog/article-2' },
     *    ],
     *  });
     * ```
     *
     * @param keys An array of delivery IDs of the content you wish to fetch
     * @typeparam Body The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @returns `Promise<FetchResponse<Body>>`
     */
    ContentClient.prototype.getContentItemsByKey = function (keys) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('getContentItemsByKey');
        }
        return new GetContentItemsV2Impl_1.GetContentItemsV2Impl(this.config, this.contentClient).getContentItemsByKey(keys);
    };
    /**
     * This function will help construct requests for fetching multiple Content Items or Slots by delivery key and/or id
     * and is equivalent to:
     *
     * ```ts
     *  client.fetchContentItems({
     *    parameters: {
     *      depth: 'all',
     *      format: 'inlined'
     *    },
     *    requests: [
     *      { id: '6cd4de36-591b-4ca2-874b-1dec7b681d7e' },
     *      { key: 'blog/article-1' },
     *    ],
     *  });
     * ```
     *
     * @param requests An array of delivery IDs of the content you wish to fetch
     * @param parameters Optional override of default parameters
     * @typeparam Body The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @returns `Promise<FetchResponse<Body>>`
     */
    ContentClient.prototype.getContentItems = function (requests, parameters) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('getContentItems');
        }
        return new GetContentItemsV2Impl_1.GetContentItemsV2Impl(this.config, this.contentClient).getContentItems(requests, parameters);
    };
    /**
     * This function will help construct requests for fetching multiple Content Items or Slots by delivery key or ID. Wraps [`/content/fetch`](https://amplience.com/docs/api/dynamic-content/delivery/content-delivery-2/index.html#operation/multiGetContent) endpoint.
     * [Additional documentation](https://amplience.com/docs/development/contentdelivery/readme.html#multipleitems)
     *
     * @param body The request body. Can include per item parameters as well as global parameters
     * @typeparam Body The type of content returned. This is optional and by default the content returned is assumed to be “any”.
     * @returns `Promise<FetchResponse<Body>>`
     */
    ContentClient.prototype.fetchContentItems = function (body) {
        if (!(0, config_1.isContentClientConfigV2)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV2Error('fetchContentItems');
        }
        return new GetContentItemsV2Impl_1.GetContentItemsV2Impl(this.config, this.contentClient).fetchContentItems(body);
    };
    /**
     * Converts a Content Item or Slot into a custom format (e.g. HTML / XML) by applying a template server side.
     * @param contentItemId Unique id of the Content Item or Slot to convert using the rendering service
     * @param templateName Name of the template to render the content item or slot with. The template must be setup in your account
     * @param customParameters Custom parameters which will be sent to the rendering API and made avaliable to your template
     */
    ContentClient.prototype.renderContentItem = function (contentItemId, templateName, customParameters) {
        if (!(0, config_1.isContentClientConfigV1)(this.config)) {
            throw new NotSupportedError_1.NotSupportedV1Error('renderContentItem');
        }
        return new RenderContentItem_1.RenderContentItem(this.config, this.contentClient).renderContentItem(contentItemId, templateName, customParameters);
    };
    /**
     * Creates a parser which converts content JSON into classes and objects used by the SDK
     * @param config
     * @hidden
     */
    ContentClient.prototype.createContentMapper = function (config) {
        return new ContentMapper_1.ContentMapper(config);
    };
    return ContentClient;
}());
exports.ContentClient = ContentClient;
//# sourceMappingURL=data:application/json;base64,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